import {get} from '../utils/http';
import TrafficRules from '../models/TrafficRules';

// 通过trip_id获取交规指南
export function getListByTripId(trip_id) {
  let url = '/m/v2/?m=api/trip/get_attach_info&scope=traffic_rules_guide';

  return get(url, {
    data: {trip_id}
  })
    .then(function (data) {
      data = data.traffic_rules_guide.list.map(function (item) {
        return TrafficRules.parseInput(item);
      });;

      return data;
    });
}




// WEBPACK FOOTER //
// ./src/services/trafficRules.js